/** API Core */
export const coreProgramsRoute = 'programs';
export const coreProgramRoute = `programs/get`;
export const coreProgramByIdRoute = (programUUID: string) => `programs/${programUUID}`;

/** API Corporate */
export const corporateProgramsRoute = 'programs';
export const corporateProgramByIdRoute = (programUUID: string) => `programs/${programUUID}`;
